// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__nbJY5","fade-in":"Modal_fade-in__2uANH","modal":"Modal_modal__l4yBn","modal-fade-in":"Modal_modal-fade-in__cW4Sc","closeButton":"Modal_closeButton__Foob_"};